import { render, staticRenderFns } from "./ElementImage.vue?vue&type=template&id=8ad4b6c0&"
import script from "./ElementImage.vue?vue&type=script&lang=ts&"
export * from "./ElementImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports